var render = function render(){var _vm=this,_c=_vm._self._c;return _c('DashboardSelect',{attrs:{"options":_vm.defOptions,"placeholder":_vm.placeholder,"multiple":_vm.multiple},on:{"input":function($event){return _vm.$emit('input', $event)},"change":function($event){return _vm.$emit('change', $event)}},model:{value:(_vm.localValue),callback:function ($$v) {_vm.localValue=$$v},expression:"localValue"}})
}
var staticRenderFns = []

export { render, staticRenderFns }